import { Component, Input } from '@angular/core';
import { Socio } from '../socio';

@Component({
    selector: 'sgt-socio-table',
    templateUrl: './socio-table.component.html',
    styleUrls: ['./socio-table.component.less']
})
export class SocioTableComponent {
    @Input() socios: Socio[];
    @Input() emptyText = 'Nenhum sócio encontrado';
}
